import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import e from "../core/Error.js";
import { formatFileSize as s } from "../core/unitFormatUtils.js";
import { on as i, init as a } from "../core/watchUtils.js";
import { aliasOf as n } from "../core/accessorSupport/decorators/aliasOf.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { cast as r } from "../core/accessorSupport/decorators/cast.js";
import { property as o } from "../core/accessorSupport/decorators/property.js";
import { subclass as l } from "../core/accessorSupport/decorators/subclass.js";
import m from "./Widget.js";
import d from "./Attachments/AttachmentsViewModel.js";
import { isSupportedImage as c, getIconPath as h } from "./Attachments/support/attachmentUtils.js";
import { storeNode as u, discardNode as p, isRTL as b } from "./support/widgetUtils.js";
import { messageBundle as g } from "./support/decorators/messageBundle.js";
import "../core/Logger.js";
import { tsx as _ } from "./support/jsxFactory.js";
var f = {
  addButton: !0,
  addSubmitButton: !0,
  cancelAddButton: !0,
  cancelUpdateButton: !0,
  deleteButton: !0,
  errorMessage: !0,
  progressBar: !0,
  updateButton: !0
},
    v = {
  base: "esri-attachments",
  loaderContainer: "esri-attachments__loader-container",
  loader: "esri-attachments__loader",
  fadeIn: "esri-attachments--fade-in",
  container: "esri-attachments__container",
  containerList: "esri-attachments__container--list",
  containerPreview: "esri-attachments__container--preview",
  actions: "esri-attachments__actions",
  deleteButton: "esri-attachments__delete-button",
  addAttachmentButton: "esri-attachments__add-attachment-button",
  errorMessage: "esri-attachments__error-message",
  items: "esri-attachments__items",
  item: "esri-attachments__item",
  itemButton: "esri-attachments__item-button",
  itemMask: "esri-attachments__item-mask",
  itemMaskIcon: "esri-attachments__item-mask--icon",
  itemImage: "esri-attachments__image",
  itemImageResizable: "esri-attachments__image--resizable",
  itemLabel: "esri-attachments__label",
  itemFilename: "esri-attachments__filename",
  itemChevronIcon: "esri-attachments__item-chevron-icon",
  itemLink: "esri-attachments__item-link",
  itemLinkOverlay: "esri-attachments__item-link-overlay",
  itemLinkOverlayIcon: "esri-attachments__item-link-overlay-icon",
  itemEditIcon: "esri-attachments__item-edit-icon",
  itemAddIcon: "esri-attachments__item-add-icon",
  itemAddButton: "esri-attachments__item-add-button",
  formNode: "esri-attachments__form-node",
  fileFieldset: "esri-attachments__file-fieldset",
  fileLabel: "esri-attachments__file-label",
  fileName: "esri-attachments__file-name",
  fileInput: "esri-attachments__file-input",
  metadata: "esri-attachments__metadata",
  metadataFieldset: "esri-attachments__metadata-fieldset",
  progressBar: "esri-attachments__progress-bar",
  esriWidget: "esri-widget",
  esriButton: "esri-button",
  buttonDisabled: "esri-button--disabled",
  esriButtonSecondary: "esri-button--secondary",
  esriButtonTertiary: "esri-button--tertiary",
  esriButtonThird: "esri-button--third",
  esriButtonSmall: "esri-button--small",
  esriButtonHalf: "esri-button--half",
  empty: "esri-widget__content--empty",
  iconExternalLink: "esri-icon-link-external",
  iconEdit: "esri-icon-edit",
  iconRight: "esri-icon-right",
  iconLeft: "esri-icon-left",
  iconPlus: "esri-icon-plus"
},
    y = window.CSS;

var B = /*#__PURE__*/function (_m) {
  _inherits(B, _m);

  var _super = _createSuper(B);

  function B(t, e) {
    var _this;

    _classCallCheck(this, B);

    _this = _super.call(this, t, e), _this.abilities = null, _this.displayType = "auto", _this.graphic = null, _this.label = void 0, _this.messages = null, _this.messagesUnits = null, _this.selectedFile = null, _this.submitting = !1, _this.viewModel = new d(), _this.visibleElements = _objectSpread({}, f), _this._supportsImageOrientation = y && y.supports && y.supports("image-orientation", "from-image"), _this._addAttachmentForm = null, _this._updateAttachmentForm = null;
    return _this;
  }

  _createClass(B, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.own(i(this, "viewModel.attachmentInfos", "change", function () {
        return _this2.scheduleRender();
      }), a(this, "viewModel.mode", function () {
        return _this2._modeChanged();
      }));
    }
  }, {
    key: "effectiveDisplayType",
    get: function get() {
      return "auto" === this.displayType ? this.viewModel.supportsResizeAttachments ? "preview" : "list" : this.displayType;
    }
  }, {
    key: "castVisibleElements",
    value: function castVisibleElements(t) {
      return _objectSpread(_objectSpread({}, f), t);
    }
  }, {
    key: "addAttachment",
    value: function addAttachment() {
      var _this3 = this;

      var t = this._addAttachmentForm,
          s = this.viewModel;
      return this._set("submitting", !0), this._set("error", null), s.addAttachment(t).then(function (t) {
        return _this3._set("submitting", !1), _this3._set("error", null), s.mode = "view", t;
      }).catch(function (t) {
        throw _this3._set("submitting", !1), _this3._set("error", new e("attachments:add-attachment", _this3.messages.addErrorMessage, t)), t;
      });
    }
  }, {
    key: "deleteAttachment",
    value: function deleteAttachment(t) {
      var _this4 = this;

      var s = this.viewModel;
      return this._set("submitting", !0), this._set("error", null), s.deleteAttachment(t).then(function (t) {
        return _this4._set("submitting", !1), _this4._set("error", null), s.mode = "view", t;
      }).catch(function (t) {
        throw _this4._set("submitting", !1), _this4._set("error", new e("attachments:delete-attachment", _this4.messages.deleteErrorMessage, t)), t;
      });
    }
  }, {
    key: "updateAttachment",
    value: function updateAttachment() {
      var _this5 = this;

      var t = this.viewModel,
          s = this._updateAttachmentForm;
      return this._set("submitting", !0), this._set("error", null), t.updateAttachment(s).then(function (e) {
        return _this5._set("submitting", !1), _this5._set("error", null), t.mode = "view", e;
      }).catch(function (t) {
        throw _this5._set("submitting", !1), _this5._set("error", new e("attachments:update-attachment", _this5.messages.updateErrorMessage, t)), t;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.submitting,
          e = this.viewModel,
          s = e.state;
      return _("div", {
        class: this.classes(v.base, v.esriWidget)
      }, t ? this.renderProgressBar() : null, "loading" === s ? this.renderLoading() : this.renderAttachments(), this.renderErrorMessage());
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      var t = this.error,
          e = this.visibleElements;
      return t && e.errorMessage ? _("div", {
        key: "error-message",
        class: v.errorMessage
      }, t.message) : null;
    }
  }, {
    key: "renderAttachments",
    value: function renderAttachments() {
      var _this$viewModel = this.viewModel,
          t = _this$viewModel.mode,
          e = _this$viewModel.activeAttachmentInfo;
      return "add" === t ? this.renderAddForm() : "edit" === t ? this.renderDetailsForm(e) : this.renderAttachmentContainer();
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return _("div", {
        class: v.loaderContainer,
        key: "loader"
      }, _("div", {
        class: v.loader
      }));
    }
  }, {
    key: "renderProgressBar",
    value: function renderProgressBar() {
      return this.visibleElements.progressBar ? _("div", {
        class: v.progressBar,
        key: "progress-bar"
      }) : null;
    }
  }, {
    key: "renderAddForm",
    value: function renderAddForm() {
      var t = this.submitting,
          e = this.selectedFile,
          s = t || !e,
          i = this.visibleElements.cancelAddButton ? _("button", {
        type: "button",
        bind: this,
        disabled: t,
        onclick: this._cancelForm,
        class: this.classes(v.esriButton, v.esriButtonTertiary, v.esriButtonSmall, v.esriButtonHalf, t && v.buttonDisabled)
      }, this.messages.cancel) : null,
          a = this.visibleElements.addSubmitButton ? _("button", {
        type: "submit",
        disabled: s,
        class: this.classes(v.esriButton, v.esriButtonSecondary, v.esriButtonSmall, v.esriButtonHalf, _defineProperty({}, v.buttonDisabled, s))
      }, this.messages.add) : null,
          n = e ? _("span", {
        key: "file-name",
        class: v.fileName
      }, e.name) : null,
          r = _("form", {
        bind: this,
        afterCreate: u,
        afterRemoved: p,
        "data-node-ref": "_addAttachmentForm",
        onsubmit: this._submitAddAttachment
      }, _("fieldset", {
        class: v.fileFieldset
      }, n, _("label", {
        class: this.classes(v.fileLabel, v.esriButton, v.esriButtonSecondary)
      }, e ? this.messages.changeFile : this.messages.selectFile, _("input", {
        class: v.fileInput,
        type: "file",
        name: "attachment",
        bind: this,
        onchange: this._handleFileInputChange
      }))), a, i);

      return _("div", {
        key: "add-form-container",
        class: v.formNode
      }, r);
    }
  }, {
    key: "renderDetailsForm",
    value: function renderDetailsForm(t) {
      var _this6 = this;

      var e = this.visibleElements,
          i = this.viewModel,
          a = this.selectedFile,
          n = this.submitting,
          r = t.contentType,
          o = t.size,
          l = t.url,
          m = i.abilities,
          d = n || !a,
          c = m.editing && m.operations.delete && e.deleteButton ? _("button", {
        key: "delete-button",
        type: "button",
        disabled: n,
        bind: this,
        onclick: function onclick(e) {
          return _this6._submitDeleteAttachment(e, t);
        },
        class: this.classes(v.esriButton, v.esriButtonSmall, v.esriButtonTertiary, v.deleteButton, _defineProperty({}, v.buttonDisabled, n))
      }, this.messages.delete) : null,
          h = m.editing && m.operations.update && e.updateButton ? _("button", {
        disabled: d,
        key: "update-button",
        type: "submit",
        class: this.classes(v.esriButton, v.esriButtonSmall, v.esriButtonThird, _defineProperty({}, v.buttonDisabled, d))
      }, this.messages.update) : null,
          b = this.visibleElements.cancelUpdateButton ? _("button", {
        disabled: n,
        key: "cancel-button",
        type: "button",
        bind: this,
        onclick: this._cancelForm,
        class: this.classes(v.esriButton, v.esriButtonSmall, v.esriButtonTertiary, v.esriButtonThird, _defineProperty({}, v.buttonDisabled, n))
      }, this.messages.cancel) : null,
          g = a ? _("span", {
        key: "file-name",
        class: v.fileName
      }, a.name) : null,
          f = m.editing && m.operations.update ? _("fieldset", {
        key: "file",
        class: v.fileFieldset
      }, g, _("label", {
        class: this.classes(v.fileLabel, v.esriButton, v.esriButtonSecondary)
      }, this.messages.changeFile, _("input", {
        class: v.fileInput,
        type: "file",
        name: "attachment",
        bind: this,
        onchange: this._handleFileInputChange
      }))) : null,
          y = _("fieldset", {
        key: "size",
        class: v.metadataFieldset
      }, _("label", null, s(this.messagesUnits, o))),
          _B = _("fieldset", {
        key: "content-type",
        class: v.metadataFieldset
      }, _("label", null, r)),
          A = _("form", {
        bind: this,
        afterCreate: u,
        afterRemoved: p,
        "data-node-ref": "_updateAttachmentForm",
        onsubmit: this._submitUpdateAttachment
      }, _("div", {
        class: v.metadata
      }, y, _B), f, _("div", {
        class: v.actions
      }, c, b, h));

      return _("div", {
        key: "edit-form-container",
        class: v.formNode
      }, _("a", {
        class: v.itemLink,
        href: l,
        rel: "noreferrer",
        target: "_blank"
      }, this.renderImageMask({
        attachmentInfo: t,
        size: 400
      }), _("div", {
        class: v.itemLinkOverlay
      }, _("span", {
        class: v.itemLinkOverlayIcon
      }, _("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, _("path", {
        d: "M28 13h1v16H3V3h16v1H4v24h24zm-5-9h4.293L15.646 15.638l.707.707L28 4.707V9h1V3h-6z"
      }), _("path", {
        fill: "none",
        d: "M0 0h32v32H0z"
      }))))), A);
    }
  }, {
    key: "renderImageMask",
    value: function renderImageMask(_ref) {
      var t = _ref.attachmentInfo,
          e = _ref.size;

      var s = this.viewModel.supportsResizeAttachments,
          i = t.contentType,
          a = t.name,
          n = t.url,
          r = s && c(i),
          o = this._getCSSTransform(t, r),
          l = o ? {
        transform: o,
        "image-orientation": "none"
      } : {},
          m = -1 === n.indexOf("?") ? "?" : "&",
          d = r ? "".concat(n).concat(m, "w=").concat(e) : h(i),
          u = _defineProperty({}, v.itemMaskIcon, !r),
          p = _defineProperty({}, v.itemImageResizable, s);

      return _("div", {
        class: this.classes(u, v.itemMask)
      }, _("img", {
        styles: l,
        alt: a,
        src: d,
        class: this.classes(p, v.itemImage)
      }));
    }
  }, {
    key: "renderAttachmentInfo",
    value: function renderAttachmentInfo(_ref2) {
      var _this7 = this;

      var t = _ref2.attachmentInfo,
          e = _ref2.displayType;
      var s = this.viewModel,
          i = s.abilities,
          a = t.name,
          n = t.url,
          r = this.renderImageMask({
        attachmentInfo: t,
        size: "list" === e ? 48 : 400
      }),
          o = i.editing ? _("span", {
        "aria-hidden": "true",
        class: this.classes(v.itemChevronIcon, b(this.container) ? v.iconLeft : v.iconRight)
      }) : null,
          l = [r, _("label", {
        class: v.itemLabel
      }, _("span", {
        class: v.itemFilename
      }, a || this.messages.noTitle), o)],
          m = i.editing ? _("button", {
        key: "details-button",
        bind: this,
        class: v.itemButton,
        title: this.messages.attachmentDetails,
        "aria-label": this.messages.attachmentDetails,
        "data-attachment-info-id": t.id,
        onclick: function onclick() {
          return _this7._startEditAttachment(t);
        },
        type: "button"
      }, l) : _("a", {
        key: "details-link",
        class: v.itemButton,
        href: n,
        target: "_blank"
      }, l);
      return _("li", {
        class: v.item,
        key: t
      }, m);
    }
  }, {
    key: "renderAttachmentContainer",
    value: function renderAttachmentContainer() {
      var _r,
          _this8 = this;

      var t = this.effectiveDisplayType,
          e = this.viewModel,
          s = this.visibleElements,
          i = e.attachmentInfos,
          a = e.abilities,
          n = i && i.length,
          r = (_r = {}, _defineProperty(_r, v.containerList, "preview" !== t), _defineProperty(_r, v.containerPreview, "preview" === t), _r),
          o = a.editing && a.operations.add && s.addButton ? _("button", {
        bind: this,
        onclick: function onclick() {
          return _this8._startAddAttachment();
        },
        class: this.classes(v.esriButton, v.esriButtonTertiary, v.addAttachmentButton),
        type: "button"
      }, _("span", {
        "aria-hidden": "true",
        class: this.classes(v.itemAddIcon, v.iconPlus)
      }), this.messages.add) : null,
          l = n ? _("ul", {
        class: v.items
      }, i.toArray().map(function (e) {
        return _this8.renderAttachmentInfo({
          attachmentInfo: e,
          displayType: t
        });
      })) : _("div", {
        class: v.empty
      }, this.messages.noAttachments);
      return _("div", {
        key: "attachments-container",
        class: this.classes(v.container, r)
      }, l, o);
    }
  }, {
    key: "_modeChanged",
    value: function _modeChanged() {
      this._set("error", null), this._set("selectedFile", null);
    }
  }, {
    key: "_handleFileInputChange",
    value: function _handleFileInputChange(t) {
      var e = t.target,
          s = e && e.files && e.files.item(0);

      this._set("selectedFile", s);
    }
  }, {
    key: "_submitDeleteAttachment",
    value: function _submitDeleteAttachment(t, e) {
      t.preventDefault(), this.deleteAttachment(e);
    }
  }, {
    key: "_submitAddAttachment",
    value: function _submitAddAttachment(t) {
      t.preventDefault(), this.addAttachment();
    }
  }, {
    key: "_submitUpdateAttachment",
    value: function _submitUpdateAttachment(t) {
      t.preventDefault(), this.updateAttachment();
    }
  }, {
    key: "_startEditAttachment",
    value: function _startEditAttachment(t) {
      var e = this.viewModel;
      e.activeAttachmentInfo = t, e.mode = "edit";
    }
  }, {
    key: "_startAddAttachment",
    value: function _startAddAttachment() {
      this.viewModel.mode = "add";
    }
  }, {
    key: "_cancelForm",
    value: function _cancelForm(t) {
      t.preventDefault(), this.viewModel.mode = "view";
    }
  }, {
    key: "_getCSSTransform",
    value: function _getCSSTransform(t, e) {
      var s = t.orientationInfo;
      return !this._supportsImageOrientation && e && s ? [s.rotation ? "rotate(".concat(s.rotation, "deg)") : "", s.mirrored ? "scaleX(-1)" : ""].join(" ") : "";
    }
  }]);

  return B;
}(m);

t([n("viewModel.abilities")], B.prototype, "abilities", void 0), t([o()], B.prototype, "displayType", void 0), t([o({
  readOnly: !0
})], B.prototype, "effectiveDisplayType", null), t([n("viewModel.graphic")], B.prototype, "graphic", void 0), t([o({
  aliasOf: {
    source: "messages.widgetLabel",
    overridable: !0
  }
})], B.prototype, "label", void 0), t([o(), g("esri/widgets/Attachments/t9n/Attachments")], B.prototype, "messages", void 0), t([o(), g("esri/core/t9n/Units")], B.prototype, "messagesUnits", void 0), t([o({
  readOnly: !0
})], B.prototype, "selectedFile", void 0), t([o({
  readOnly: !0
})], B.prototype, "submitting", void 0), t([o({
  readOnly: !0
})], B.prototype, "error", void 0), t([o({
  type: d
})], B.prototype, "viewModel", void 0), t([o()], B.prototype, "visibleElements", void 0), t([r("visibleElements")], B.prototype, "castVisibleElements", null), B = t([l("esri.widgets.Attachments")], B);
var A = B;
export { A as default };